import React from "react";

const CloseIcon = () => (
  <svg
    width="14px"
    height="14px"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M1 1.18042L9 9.18042" stroke="#666666" strokeWidth="1.5" />
    <path d="M1 9.18042L9 1.18042" stroke="#666666" strokeWidth="1.5" />
  </svg>
);

export default CloseIcon;
